module.exports = __webpack_public_path__ + "img/stop.240b3458.svg";